import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import {
  PerformanceStore,
  usePerformanceActions,
  useCustomerHasAccessToPerformance,
  useCurrentWorkspaceId,
} from 'src/store';
import { captureMessage } from 'src/utils/lib/sentry';
import { ADS_CHANNELS, REVIEWS_CHANNELS, WEBSITE_CHANNELS } from 'src/data/performance';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'connectedAccountsFetched',
  'selectedAccountIds',
  'extractingCopies',
]);

const REST_CHANNELS = [...REVIEWS_CHANNELS, ...WEBSITE_CHANNELS];

export const useGetChannelsLastExtraction = () => {
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();
  const customerHasAccessToPerformance = useCustomerHasAccessToPerformance();
  const { connectedAccountsFetched, selectedAccountIds, extractingCopies } = usePerformanceState();

  useEffect(() => {
    if (!connectedAccountsFetched) {
      return;
    }

    const channels = customerHasAccessToPerformance
      ? [...ADS_CHANNELS, ...REST_CHANNELS]
      : REST_CHANNELS;

    channels.forEach((channel) => {
      if ((selectedAccountIds[channel] || []).length === 0 || extractingCopies[channel]) {
        performanceActions.setLoadingConnectedAccounts(false);
        return;
      }

      performanceActions.getChannelLastExtraction(channel).catch((error) => {
        captureMessage('Error getting channel last extraction', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'useGetChannelsLastExtraction',
          },
        });
      });
    });
  }, [
    connectedAccountsFetched,
    customerHasAccessToPerformance,
    selectedAccountIds,
    extractingCopies,
    performanceActions,
    currentWorkspaceId,
  ]);
};
